module.exports = __webpack_public_path__ + "img/free-player.056a24bd.png";